<template>
  <div class="page-container">
    <SLandingTopBar />
    <SSubHeader pageName="Account activation" />
    <div class="header-spacer--standard"></div>
    <div class="container activation-container">
      <div class="row">
        <div class="col-12">
          <div class="ui-block">
            <div class="ui-block-content">
              <p class="activation-form-info">
                Please provide the following information (those marked with *
                are required)
              </p>
              <form>
                <div class="row activation-content">
                  <div v-if="isFacebook">
                    <form>
                      <div class="md-layout md-gutter" style="width: 44vw">
                        <div class="md-layout-item">
                          <SInput
                            label="Username"
                            ref="username"
                            fieldClass="form-input"
                            :class="[
                              {
                                'has-value':
                                  credentials.username &&
                                  checkUsrName === false,
                              },
                            ]"
                            @atBlur="checkUsernameAvailability"
                            @atFocus="clearErrors('username')"
                            :required="true"
                            v-model="credentials.username"
                          />
                        </div>
                        <div class="md-layout-item">
                          <SInput
                            type="text"
                            id="email"
                            name="email"
                            @atBlur="checkEmailAvailability"
                            :class="[
                              {
                                'has-value':
                                  credentials.email && emailTst === false,
                              },
                            ]"
                            @atFocus="clearErrors('email')"
                            label="Email"
                            ref="email"
                            fieldClass="form-input"
                            :required="true"
                            :error="emailError"
                            v-model="credentials.email"
                          />
                        </div>
                      </div>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <div
                            data-toggle="tooltip"
                            data-placement="bottom"
                            data-html="true"
                            title="<div class='text-left'><b>Password must have</b><br>
                              - at least 1 number<br>
                              - at least 1 lowercase letter<br>
                              - at least 1 uppercase letter<br>
                              - at least 8 characters
                              </div>"
                          >
                            <VuePassword
                              v-model="credentials.password"
                              :strength="passwordScore"
                              disableToggle
                            >
                              <template v-slot:password-input>
                                <div
                                  class="label-floating col-12 pl-0 pr-0 mb-0 registration-input"
                                  :class="[
                                    {
                                      'has-value':
                                        credentials.password &&
                                        pswdSpelling === true,
                                    },
                                  ]"
                                >
                                  <md-field
                                    class="form-input"
                                    :class="[
                                      { 'has-error': pswdSpelling !== true },
                                    ]"
                                  >
                                    <label>Password</label>
                                    <md-input
                                      v-model="credentials.password"
                                      @input="
                                        updateStrength(credentials.password)
                                      "
                                      @blur="checkPswrdSpelling"
                                      type="password"
                                      class="form-control"
                                      :required="true"
                                      name="new-password"
                                      autocomplete="new-password"
                                    >
                                    </md-input>
                                  </md-field>
                                  <span
                                    class="spelling"
                                    v-if="pswdSpelling !== true"
                                    >{{ pswdSpelling }}</span
                                  >
                                </div>
                              </template>
                            </VuePassword>
                          </div>
                        </div>
                        <div class="md-layout-item">
                          <SInput
                            label="Confirm password"
                            type="password"
                            ref="passwordConfirmation"
                            :class="[
                              {
                                'has-value':
                                  credentials.passwordConfirmation &&
                                  pwdTst === true,
                              },
                            ]"
                            fieldClass="form-input"
                            :required="true"
                            @atBlur="checkPassword"
                            @atFocus="clearErrors('passwordConfirmation')"
                            v-model="credentials.passwordConfirmation"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="text-centered activation-content">
                  <div class="md-layout md-gutter" style="width: 44vw">
                    <div class="md-layout-item">
                      <SInput
                        id="activation_firstName"
                        name="firstName"
                        label="First name"
                        type="text"
                        ref="firstName"
                        :class="[{ 'has-value': credentials.firstName }]"
                        @atBlur="checkName"
                        @atFocus="clearErrors('firstName')"
                        fieldClass="form-input"
                        :required="true"
                        :acceptOnlyLetters="true"
                        v-model="credentials.firstName"
                      />
                    </div>
                    <div class="md-layout-item">
                      <SInput
                        label="Last name"
                        :class="[{ 'has-value': credentials.lastName }]"
                        ref="lastName"
                        fieldClass="form-input"
                        :acceptOnlyLetters="true"
                        v-model="credentials.lastName"
                      />
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <VuePhoneNumberInput
                        :class="[
                          {
                            'phone-error': phoneError === true,
                            'phone-number-input': !phoneError,
                            'empty-phone-number-input':
                              !credentials.phoneNumber || !phoneError,
                          },
                        ]"
                        v-model="credentials.phoneNumber"
                        ref="phoneNumberInput"
                        @phone-number-blur="verifyPhoneNumber"
                      />
                      <p
                        class="phone-assist-error"
                        v-if="credentials.phoneNumber && phoneError"
                      >
                        You have entered an invalid phone number.
                      </p>
                    </div>
                  </div>
                  <p class="gender-input">Gender</p>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <md-radio v-model="credentials.gender" value="F"
                        >Female</md-radio
                      >
                    </div>
                    <div class="md-layout-item">
                      <md-radio v-model="credentials.gender" value="M"
                        >Male</md-radio
                      >
                    </div>
                    <div class="md-layout-item">
                      <md-radio v-model="credentials.gender" value="O"
                        >Prefer not to say</md-radio
                      >
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <SInput
                        label="ZIP code"
                        ref="zipCode"
                        @atBlur="checkZip"
                        :class="[{ 'has-value': testZipcode.type === true }]"
                        fieldClass="form-input"
                        type="text"
                        :required="true"
                        :isZipInput="true"
                        v-model="credentials.zipCode"
                      />
                    </div>
                  </div>
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                      <SInput
                      @atBlur="checkCity"
                        label="City"
                        ref="city"
                        :class="[{ 'has-value': this.credentials.city }]"
                        fieldClass="form-input"
                        type="text"
                        :required="true"
                        :acceptOnlyLetters="false"
                        v-model="credentials.city"
                        :disabled="isZipFilled"
                      />
                    </div>
                    <div class="md-layout-item">
                      <SInput
                        label="Country"
                        ref="country"
                        :class="[{ 'has-value': this.credentials.country }]"
                        fieldClass="form-input"
                        type="text"
                        :acceptOnlyLetters="false"
                        v-model="credentials.country"
                        :disabled="isZipFilled"
                      />
                    </div>
                  </div>
                  <div class="remember text-left col-12" v-if="isFacebook">
                    <SCheckbox
                      label="I accept the Swampum community’s <a href='#'>Terms and Conditions</a>"
                      v-model="checkTerms"
                    />
                    <div
                      class="text-danger mt-3 text-center"
                      v-if="
                        credentials.username &&
                        pswdSpelling &&
                        pwdTst &&
                        emailTst &&
                        checkTerms === false &&
                        typeof testZipcode.type !== 'boolean'
                      "
                    >
                      You must accept Terms and Conditions to proceed
                    </div>
                  </div>
                  <SButtonMaterial
                    class="submit-button"
                    buttonType="button"
                    color="primary"
                    textColor="white"
                    materialClass="dense"
                    text="Submit"
                    @button="submit"
                    :disabled="disabledButton || tryingToActivate"
                  />
                  <Modal
                    id="myModal"
                    buttonName="OK"
                    title="Account activation"
                    ref="modal"
                    @button="closeModal"
                    :disabled="responseMsg === null"
                    :materialButton="true"
                  >
                    <footer
                      v-if="responseMsg !== null"
                      class="h5 font-weight-normal"
                    >
                      <span v-html="responseMsg"></span>
                    </footer>

                    <div
                      class="spinner-border text-primary"
                      role="status"
                      v-else
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </Modal>
                  <Modal
                    id="expired"
                    buttonName="Resend email"
                    title="Expired token"
                    ref="expired"
                    @close="resendActivationEmail"
                    @button="resendActivationEmail"
                    :materialButton="true"
                  >
                    <footer class="h5 font-weight-normal">
                      <span class="text-danger h5 text-center">
                        Your activation token has expired. Please, click 'Resend
                        email' to receive a new email.
                      </span>
                    </footer>
                  </Modal>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Global from "@/constants/Global.js";
import SInput from "@/material-components/atoms/SInput.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import Modal from "@/components/atoms/Modal";
import SCheckbox from "@/components/atoms/SCheckbox.vue";
import store from "@/vuex/store";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SSubHeader from "@/material-components/organisms/SSubHeader.vue";
import VuePassword from "vue-password";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import zxcvbn from "zxcvbn";
import * as  axios from'axios';

export default {
  name: "ActivationForm",
  components: {
    SInput,
    SButtonMaterial,
    Modal,
    SCheckbox,
    SLandingTopBar,
    SSubHeader,
    VuePhoneNumberInput,
    VuePassword,
  },
  mixins: [UserHelperVue],
  data() {
    return {
      male: false,
      female: false,
      other: false,
      credentials: {
        username: "",
        firstName: "",
        lastName: "",
        zipCode: "",
        email: "",
        password: "",
        passwordConfirmation: "",
        gender: "",
        phoneNumber: "",
        city: "",
        country: "",
      },
      gender: [
        { value: "O", label: "Other" },
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
      ],
      isFacebook: this.$route.query.facebook,
      activate_success: false,
      activate_authenticated: false,
      checkUsrName: null,
      emailTst: null,
      checkTerms: false,
      responseMsg: null,
      pswdSpelling: "",
      pwdTst: null,
      checkFirstName: true,
      checkZipcode: false,
      tryingToActivate: false,
      phoneError: false,
      passwordScore: 0,
      isZipFilled: false,
    };
  },
  computed: {
    emailError() {
      return (typeof this.emailTst !== `boolean`)
    },
    testZipcode() {
      let isValidZip = true;
      if (this.credentials.zipCode) {
        isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.credentials.zipCode);
      } else {
        return {type: false, message: ''}
      }
      if (!isValidZip) {
        return {type: null, message: 'Zipcode must have the one of the following pattern 00000 or 00000-0000'};
      } else {
        return {type: true, message: ''};
      }
    },
    verifyCredentials() {
      if (this.credentials.phoneNumber) {
        this.verifyPhoneNumber();
        return !! this.phoneError;
      }
      return false;
    },
    disabledButton() {
      if (this.$route.query.facebook) {
        const zip_code = this.credentials.zipCode || "";
        if (
          this.credentials.firstName &&
          this.credentials.username &&
          this.credentials.password === this.credentials.passwordConfirmation &&
          this.credentials.email &&
          this.credentials.password &&
          zip_code.length >= 5 &&
          /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip_code)
        ) {
          return this.verifyCredentials
        } else {
          return true;
        }
      } else {
        const zip_code = this.credentials.zipCode || "";
        if (
          this.credentials.firstName &&
          zip_code.length >= 5 &&
          this.credentials.city &&
          /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip_code)
        ) {
          return this.verifyCredentials
        } else {
          return true;
        }
      }
    },
    usernameError() {
      const checkUsrName = this.checkUsrName;
      if (checkUsrName === "") return false;
      if (typeof checkUsrName === "string") return true;
      if (checkUsrName === null) return false;
      return checkUsrName !== false;
    },
  },
  mounted() {
    $("[data-toggle='tooltip']").tooltip();
    if (this.$route.query.facebook) {
      fetch(Global.getServerDomain() + `/profile/${this.$route.query.id}`, {
        method: "GET",
        headers: this.getHeaders(),
      })
        .then((response) => response.json())
        .then((response) => {
          this.credentials = response;
        });
    } else {
      this.$refs.firstName.focus();
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      await store.dispatch("fetchUserProfile", to.query.id);
      const isUserActived = store.getters["getUserProfile"].activated;
      if (isUserActived === 0) {
        next();
      } else if (localStorage.getItem("token")) {
        next("/s-app/feed");
      } else {
        next("/");
      }
    } catch (error) {
      console.log(error);
    }
  },
  async created() {
    await this.fetchUserProfile(this.$route.query.id);
    const session_check = await this.checkSessionDueDate({
      token: this.$route.query.token,
    });
    if (session_check.error === "Sessioin token expired") {
      $("#expired").modal("show");
    }
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape" && $("#myModal").is(":visible")) {
        this.closeModal();
      }
      if (e.key == "Escape" && $("#expired").is(":visible")) {
        this.resendActivationEmail();
      }
    });
    document.addEventListener("click", (event) => {
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#myModal").is(":visible")
      ) {
        this.closeModal();
      }
      if (
        !$(event.target).closest(".modal-content").length &&
        $("#expired").is(":visible")
      ) {
        this.resendActivationEmail();
      }
    });
  },
  methods: {
    verifyPhoneNumber() {
      if (this.credentials.phoneNumber) {
        let validPhoneNumber = this.$refs.phoneNumberInput.isValid;
        this.phoneError = !validPhoneNumber;
      } else this.phoneError = false;
    },
    updateStrength(password) {
      if (password && password !== undefined) {
        this.passwordScore = zxcvbn(password).score;
        const trTest = /^(?=.*[A-Z])(?=.*\d)(?=.{8,})/
        return Boolean(trTest.test(password));
      }
      return false;
    },
    checkName() {
      if (!this.credentials.firstName) {
        this.checkFirstName = false;
        this.$refs.firstName.setErrorMessage("First name cannot be empty");
      } else {
        this.$refs.firstName.clearError();
      }
    },
    checkCity() {
      if (!this.credentials.city) {
        this.$refs.city.setErrorMessage("City cannot be empty");
      } else {
        this.$refs.city.clearError();
      }
    },
    async checkZip() {
      if (!this.credentials.zipCode) {
        this.checkZipCode = false;
        this.$refs.zipCode.setErrorMessage("Zipcode cannot be empty");
      } else if (this.testZipcode.type !== true) {
        this.$refs.zipCode.setErrorMessage(this.testZipcode.message);
      } else {
        this.$refs.zipCode.clearError();
      }
      this.isZipFilled = false;
      this.credentials.country = "";
      this.credentials.city = "";
      if (this.credentials.zipCode.length >= 5) {
        const url = 'https://app.zipcodebase.com/api/v1/search'
        const parametros = {
          apikey: '11ae8520-0f06-11ee-b81e-9ba872d04347',
          codes: this.credentials.zipCode,
          country: 'us'
        };

        const resposta = await axios.get(url, { params: parametros });
        this.credentials.city = resposta.data.results[`${this.credentials.zipCode}`][0].city;
        this.credentials.country = "United States";
      }
    },
    clearErrors(field) {
      this.$refs[field].clearError();
    },
    resendActivationEmail() {
      this.resendActivation({
        email: this.user.email,
        token: this.$route.query.token,
      });
      this.$refs.expired.closeModal();
      this.$router.path !== "/" && this.$router.push("/");
    },
    filterUsername(event) {
      const re = /[^a-zA-Z\d\s:]/g;
      if (re.test(event.key)) {
        event.preventDefault();
      }
    },
    closeModal() {
      if (this.activate_success) {
        this.setIsFirstLogin(true);
        this.$refs.modal.closeModal();
        this.startSession();
        this.$router.push("/s-app/feed");
      } else {
        this.$refs.modal.closeModal();
      }
    },
    async submit() {
      this.checkFirstName = !! this.credentials.firstName
      this.checkZipcode = !! this.credentials.zipCode
      if (this.$route.query.facebook) {
        this.checkEmail();
        this.checkPswrdSpelling();
        this.checkPassword();
        if (
          this.credentials.username &&
          this.pswdSpelling === true &&
          this.pwdTst === true &&
          this.emailTst === true &&
          this.checkTerms === true
        )
          this.tryingToActivate = true;
        $("#myModal").modal("show");
        this.submitFacebook();
      } else {
        this.tryingToActivate = true;
        $("#myModal").modal("show");
        this.submitCommon();
      }
    },
    checkUsernameAvailability() {
      if (this.credentials.username) {
        fetch(Global.getServerDomain() + `/usernameAvailability`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: this.credentials.username,
          }),
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.available) {
              this.checkUsrName = false;
            } else {
              this.checkUsrName = response.result;
              this.$refs.username.setErrorMessage(response.result);
            }
          });
      } else {
        this.checkUsrName = "Please provide a valid username";
        this.$refs.username.setErrorMessage("Please provide a valid username");
      }
    },
    checkEmailAvailability() {
      if (this.credentials.email) {
        fetch(Global.getServerDomain() + `/emailAvailability`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: this.credentials.email,
          }),
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.available) {
              this.emailTst = false;
            } else {
              this.emailTst = response.result || response.error;
              this.$refs.email.setErrorMessage(this.emailTst);
            }
          });
      }
    },
    async submitFacebook() {
      if (this.credentials.phoneNumber === null)
        this.credentials.phoneNumber = "";
      await fetch(
        Global.getServerDomain() +
          "/facebookActivation/" +
          this.$route.query.id,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: this.credentials.username,
            firstName: this.credentials.firstName,
            lastName: this.credentials.lastName,
            zip_code: this.credentials.zipCode,
            email: this.credentials.email,
            password: this.credentials.password,
            gender: this.credentials.gender,
            phone_number: this.credentials.phoneNumber,
            city: this.credentials.city,
            country: this.credentials.country,
          }),
        }
      )
        .then((res) => res.json())
        .then((response) => {
          if (!response.error && response.result === "Activation successful") {
            localStorage.setItem("token", this.$route.query.fbtoken);
            this.activate_success = true;
            this.startSession();
            this.responseMsg = `Welcome, activation successful.<br><br>You will be redirected now.`;
          } else if (!response.available) {
            this.activate_authenticated = true;
            this.responseMsg = response.result;
          } else if (response.error) {
            this.responseMsg = response.error;
          }
          this.tryingToActivate = false;
        });
    },
    async submitCommon() {
      if (this.credentials.phoneNumber === null)
        this.credentials.phoneNumber = "";
      const result = await fetch(Global.getServerDomain() + "/activation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: this.user.username,
          firstName: this.credentials.firstName,
          lastName: this.credentials.lastName,
          zip_code: this.credentials.zipCode,
          email: this.user.email,
          id: this.$route.query.id,
          gender: this.credentials.gender,
          phone_number: this.credentials.phoneNumber,
          city: this.credentials.city,
          country: this.credentials.country,
        }),
      })
        .then((res) => res.json())
        .then((response) => {
          if (!response.error && response.result === "Activation successful") {
            localStorage.setItem("token", this.$route.query.token);
            this.activate_success = true;
            this.startSession();
            this.responseMsg = `Welcome, activation successful.<br><br>You will be redirected now.`;
          } else if (!response.available) {
            this.activate_authenticated = true;
            this.responseMsg = response.error;
          } else if (response.error) {
            this.responseMsg = response.error;
          }
          this.tryingToActivate = false;
        });
      return result;
    },
    getHeaders() {
      return {
        "Content-Type": "application/json",
        auth_key: window.localStorage.getItem("token"),
      };
    },
    checkPswrdSpelling() {
      if ((/(?=.*[A-Z])/).test(this.credentials.password)) {
        this.pswdSpelling = "Password must have at least 1 uppercase letter";
      } else if (! (/(?=.*\d)/).test(this.credentials.password)) {
        this.pswdSpelling = "Password must have at least 1 number";
      } else if (! (/(?=.{8,})/).test(this.credentials.password)) {
        this.pswdSpelling = "Password must have at least 8 charcters";
      } else if (! (/(?=.*[a-z])/).test(this.credentials.password)) {
        this.pswdSpelling = "Password must have at least 1 lowercase letter";
      } else {
        this.pswdSpelling = true;
      }
    },
    checkPassword() {
      if (!this.credentials.passwordConfirmation) {
        this.pwdTst = "This field cannot be empty";
        this.$refs.passwordConfirmation.setErrorMessage(
          "This field cannot be empty"
        );
      } else if (
        this.credentials.password !== this.credentials.passwordConfirmation
      ) {
        this.pwdTst = "Both password fields must be the same";
        this.$refs.passwordConfirmation.setErrorMessage(
          "Both password fields must be the same"
        );
      } else {
        this.$refs.passwordConfirmation.clearError();
        this.pwdTst = true;
      }
    },
    checkEmail() {
      if (
        ! (
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        ).test(this.credentials.email)
      ) {
        this.emailTst = "This field must be a valid email";
      } else if (this.emailTst === "Email already taken") {
        return;
      } else {
        this.emailTst = true;
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 960px) {
  .header-spacer--standard {
    height: 192px;
  }
  .md-gutter {
    width: unset !important;
  }
}
@media screen and (max-width: 1024px) {
  .header-spacer--standard {
    height: 220px;
  }
}
</style>

<style lang="scss" scoped>
.activation-form-info {
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 1.25px;
  color: $black;
}
.ui-block-content {
  border: 1px solid $black;
  border-radius: 5px;
}
.activation-content {
  display: grid;
  align-content: center;
  justify-content: center;
}
.phone-assist-error {
  color: $danger;
  margin-top: -22px;
  text-align: center;
}
.spelling {
  float: left;
  margin-top: 0.4em;
  color: $danger;
}
</style>

<style lang="scss">
.form-input,
.input-tel__input {
  border: 1px solid rgba(0, 0, 0, 0.62) !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
  margin-top: 1rem;
}
.md-radio.md-theme-swampum-primary.md-checked .md-radio-container:after {
  color: $primary;
  background-color: $primary;
}
.md-radio.md-theme-swampum-primary.md-checked .md-radio-container {
  border-color: $primary;
}
.md-radio.md-theme-swampum-primary.md-checked .md-radio-label {
  color: $primary !important;
}
.submit-button {
  justify-self: center;
  height: 3rem !important;
  width: 10rem;
}
.activation-container {
  min-width: 45vw;
}
.gender-input {
  color: rgba(0, 0, 0, 0.68);
  letter-spacing: 1.25px;
  margin-bottom: -0.2em;
}
.phone-number-input,
.phone-error {
  margin-bottom: 2rem;
}
</style>

<!-- Styles for phone Number input component --->
<style lang="scss">
.input-tel__input,
.country-selector__input {
  height: 48px !important;
}
.phone-number-input .input-tel__input:focus,
.country-selector__input:focus {
  box-shadow: $primary 0px 0px 0px 0.03rem !important;
}
.phone-error .input-tel__input:focus,
.input-tel__input {
  box-shadow: $danger 0px 0px 0px 0.03rem !important;
}
.empty-phone-number-input .input-tel__input {
  box-shadow: none !important;
}
.phone-number-input .input-tel__label,
.country-selector__label,
.country-selector__label:focus {
  color: $primary !important;
}
.phone-error .input-tel__label,
.country-selector__label:focus {
  color: $danger !important;
}
.country-selector__input {
  border: 1px solid rgba(0, 0, 0, 0.62) !important;
  border-radius: 7px 0px 0px 7px !important;
  border-width: 1px 0 1px 1px !important;
  margin-top: 1rem;
  padding-top: 20px !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.has-value .md-field.md-theme-swampum-primary label {
  color: $primary !important;
}
input {
  cursor: pointer;
}
</style>

<!-- Styles for Vue password auto & error class --->
<style lang="scss" scoped>
.md-focused {
  border-color: $primary !important;
}
.md-field.md-theme-swampum-primary.md-focused label {
  color: $primary;
}
a {
  color: $primary !important;
}
label {
  font-size: 14px;
  margin-left: 11px;
  top: 15px;
}
.md-input {
  width: 100%;
  height: 100%;
}
input {
  margin-left: 11px;
  padding-top: 5px !important;
}
.md-field:after {
  height: 0;
}
.md-field:before {
  height: 0px;
}
.form-input {
  margin-bottom: 0 !important;
}
.has-error {
  border: 1px $danger solid !important;
}
.has-error label {
  color: $danger !important;
}
.has-error input {
  color: $danger !important;
}
</style>
